import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { cancelSubscription, getUserProfile } from "../../requests";
import { notifySuccess, notifyError } from "../../utils/helper";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import "../../_css/SubscriptionInfo.css";

const SubscriptionInfo = () => {
  const dispatch = useDispatch();
  const { remainingUploads } = useSelector((state) => state.plan);
  const [planInfo, setPlanInfo] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    fetchPlanInfo();
  }, []);

  const fetchPlanInfo = async () => {
    try {
      const res = await getUserProfile();
      if (res?.data?.planInfo) {
        setPlanInfo(res.data.planInfo);
      }
    } catch (error) {
      console.error("Error fetching plan info:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleCancelSubscription = async () => {
    if (
      !window.confirm(
        "This action cannot be undone. Are you sure you want to cancel your subscription?"
      )
    ) {
      return;
    }

    dispatch(startLoader());
    try {
      const response = await cancelSubscription();
      if (response.data.message) {
        notifySuccess("Subscription cancelled successfully");
        fetchPlanInfo();
      }

    } catch (error) {
      notifyError(
        error?.response?.data?.error ||
          "Failed to cancel subscription. Please try again later."
      );
    } finally {
      dispatch(stopLoader());
    }
  };

  const getPlanColor = () => {
    if (!planInfo) return "#03A3E3";
    const planName = planInfo?.plan_name?.toLowerCase() || "";
    if (planName.includes("trial")) return "#FCD34D";
    if (planName.includes("expired")) return "#EF4444";
    return "#03A3E3";
  };

  if (!planInfo) {
    return (
      <div className="subscription-info-container">
        <div className="subscription-info-loading">
          Loading subscription info...
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-info-container">
      <h3 className="subscription-info-title">Subscription Information</h3>

      <div className="subscription-info-content">
        {/* <div className="subscription-plan-badge" style={{ backgroundColor: getPlanColor() }}>
          {planInfo.plan_name || "N/A"}
        </div> */}

        <div className="subscription-detail-item">
          <span className="subscription-detail-label">Plan Name:</span>
          <span className="subscription-detail-value">
            {planInfo.plan_name || "N/A"}
          </span>
        </div>

        <div className="subscription-detail-item">
          <span className="subscription-detail-label">Remaining Uploads:</span>
          <span className="subscription-detail-value">{remainingUploads}</span>
        </div>

        <div className="subscription-detail-item">
          <span className="subscription-detail-label">Start Date:</span>
          <span className="subscription-detail-value">
            {formatDate(planInfo.start_date)}
          </span>
        </div>

        <div className="subscription-detail-item">
          <span className="subscription-detail-label">End Date:</span>
          <span className="subscription-detail-value">
            {formatDate(planInfo.end_date)}
          </span>
        </div>

        <div className="subscription-detail-item">
          <span className="subscription-detail-label">Subscription Status:</span>
          <span
            className={`subscription-detail-value subscription-status ${
              !planInfo.is_cancelled
                ? "status-active"
                : planInfo.is_cancelled
                ? "status-cancelled"
                : ""
            }`}
          >
            {!planInfo.is_cancelled
              ? "Active"
              : planInfo.is_cancelled
              ? "Cancelled"
              : "Unknown"}
          </span>
        </div>

        {!planInfo.is_cancelled && (
          <div className="subscription-cancel-section">
            <button
              className="subscription-cancel-button"
              onClick={handleCancelSubscription}
            >
              Cancel Subscription
            </button>

            <div
              className="subscription-info-icon-container"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <svg
                className="subscription-info-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="10"
                  cy="10"
                  r="9"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
                <path
                  d="M10 6V10M10 14H10.01"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
              {showTooltip && (
                <div className="subscription-info-tooltip">
                  Cancellation of subscription won't affect current plan. It
                  will be accessible until the last date of current
                  subscription.
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionInfo;
